import React from "react";
import { Row, Col } from "antd";

function Products({ products = [] }) {
  //  Always get the first image of the first color variant
  const getFirstImage = (product) => {
    const firstColor = product.colors?.[0];
    const firstImage = firstColor?.images?.[0];
    return firstImage || null;
  };

  //  No port needed - static files served directly
  const getImageUrl = (imagePath) => {
    if (!imagePath) return "https://via.placeholder.com/300x300?text=No+Image";
    return imagePath || "https://via.placeholder.com/300x300?text=No+Image";
  };

  if (products.length === 0) {
    return (
      <div className="text-center py-10 font-custom text-lg">
        No products found in this category.
      </div>
    );
  }

  return (
    <>
      <Row gutter={[30, 30]}>
        {products.map((product) => {
          const firstImage = getFirstImage(product);
          return (
            <Col md={6} key={product._id}>
              <div className="product-card">
                <a
                  className="product-direction hover:text-[#000]"
                  href={`/productDetail/${product.slug}`}
                >
                  <img
                    src={getImageUrl(firstImage)}
                    className="w-100 m-auto"
                    alt={product.title}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/300x300?text=No+Image";
                    }}
                  />
                  <h5 className="text-center font-bold font-custom">
                    {product.subtitle || "Brand"}
                  </h5>
                  <h4 className="text-center font-bold font-custom">
                    {product.title}
                  </h4>
                  <h3 className="text-center font-bold font-custom">
                    {product.stock} Stock | {product.colors?.length || 0} Colors
                  </h3>
                  <h5 className="text-center font-bold font-custom">
                    ${product.price?.toFixed(2)}
                    <span> each</span>
                  </h5>
                </a>
              </div>
            </Col>
          );
        })}
      </Row>
    </>
  );
}

export default Products;
